// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){
	window.addEventListener('load', function(){
		let nextArrowGal = document.querySelector('.gallery-block .slick-next');
		nextArrowGal.click();
	})

	$(document).ready(function () {

		// Select Property
		let lesplanadeArrow = document.getElementById('lesplanade-arrow');
		let lepetitArrow = document.getElementById('lepetit-arrow');
		if(lesplanadeArrow){
			lesplanadeArrow.addEventListener("click", function(){
				lepetitArrow.classList.remove('active');
				document.querySelector('.side--right').classList.remove('hover');
				document.querySelector('.side--right').classList.add('closed');

				lesplanadeArrow.classList.add('active');
				document.querySelector('.side--left').classList.remove('closed');
				document.querySelector('.side--left').classList.add('hover');
			});
		}
		if(lepetitArrow){
			lepetitArrow.addEventListener("click", function(){
				lesplanadeArrow.classList.remove('active');
				document.querySelector('.side--left').classList.remove('hover');
				document.querySelector('.side--left').classList.add('closed');

				lepetitArrow.classList.add('active');
				document.querySelector('.side--right').classList.remove('closed');
				document.querySelector('.side--right').classList.add('hover');
			});
		}
		//

		// Booking 
			let reservationsBtn = document.getElementById('reservations-js');
			let bookingSection = document.getElementById('booking-widget');
			let closeBooking = document.getElementById('close-booking-js');

			let bookingForm = document.getElementById('booking-form');
			let lesplanadeHotel = document.getElementById('lesplanade');
			let	lesplanadeHotelValue = lesplanadeHotel.getAttribute('value');
			let	lesplanadeHotelId = 'booking-form-lesplanade';
			
			let lepetitHotel = document.getElementById('lepetit');
			let	lepetitHotelValue = lepetitHotel.getAttribute('value');
			let	lepetitHotelId = 'booking-form-lepetit';

			reservationsBtn.addEventListener("click", function(){bookingSection.classList.add('open');});
			closeBooking.addEventListener("click", function(){bookingSection.classList.remove('open');});

			lesplanadeHotel.addEventListener("click", function(){
				lepetitHotel.classList.remove('active');
				this.classList.add('active');
				bookingForm.setAttribute('id', lesplanadeHotelId)
				bookingForm.setAttribute('action', lesplanadeHotelValue);
			});
			lepetitHotel.addEventListener("click", function(){
				lesplanadeHotel.classList.remove('active');
				this.classList.add('active');
				bookingForm.setAttribute('id', lepetitHotelId)
				bookingForm.setAttribute('action', lepetitHotelValue);
			});

			bookingForm.addEventListener( "submit", (e) => {

				e.target.action = e.target.action + "#checkin=" + document.querySelector("#arriveDate").value + "&checkout=" + document.querySelector("#departureDate").value
				console.log( this.action )

			} )
		// *******

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});
		;
		(function () {
			'use strict'
		  
			/**
			 * ------------------------------------------------------------------------
			 * Constants
			 * ------------------------------------------------------------------------
			 */
			const SELECTOR_DATEPICKER$1 = '#datepicker__general'
			const SELECTOR_DATEPICKER$2 = '#booking__calendars'
		  
			const SELECTOR_DATE$1 = '#arriveDate'
			const SELECTOR_DATE$2 = '#departureDate'
			const SELECTOR_DATE$3 = '#altDates'
		  
			let opened = 0
			let start = $(SELECTOR_DATE$1).attr('value')
			let end = $(SELECTOR_DATE$2).attr('value')
		  
			/**
			 * ------------------------------------------------------------------------
			 * Functions - Public
			 * ------------------------------------------------------------------------
			 */
		  
			const datepickerGeneral = () => {}
		  
			const datepickerBooking = () => {
			  $(SELECTOR_DATEPICKER$2).datepicker({
				dateFormat: 'yy-mm-dd',
				numberOfMonths: 2,
				minDate: new Date(),
				beforeShowDay: function (date) {
				  $.datepicker._defaults.dateFormat = 'yy-mm-dd'
		  
				  let startDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					start,
				  )
		  
				  let endDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					end,
				  )
		  
				  if (date.getTime() == startDate.getTime()) {
					return [true, 'startday']
				  } else {
					if (date.getTime() == endDate.getTime()) {
					  return [true, 'endday']
					} else {
					  if (
						date.getTime() > startDate.getTime() &&
						date.getTime() < endDate.getTime()
					  ) {
						return [true, 'days']
					  } else {
						return [true, '']
					  }
					}
				  }
				},
				onSelect: function (date) {
				  let arrive = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					start,
				  )
				  let departure = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					end,
				  )
				  let selectedDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					date,
				  )
		  
				  if (opened == 0) {
					opened = 1
					start = date
					end = date
				  } else {
					opened = 0
					if (selectedDate <= arrive) {
					  end = start
					  start = date
					} else {
					  end = date
					}
				  }
		  
				  $(SELECTOR_DATE$1).attr('value', start)
				  $(SELECTOR_DATE$2).attr('value', end)
		  
				  let SplitArrive = start.split('-')
				  let SplitDeparture = end.split('-')
		  
				  $(SELECTOR_DATE$3).attr(
					'value',
					SplitArrive[0] +
					  '-' +
					  SplitArrive[1] +
					  '-' +
					  SplitArrive[2] +
					  ' / ' +
					  (SplitDeparture[0] +
						'-' +
						SplitDeparture[1] +
						'-' +
						SplitDeparture[2]),
				  )
				},
			  })
			}
		  
			/**
			 * ------------------------------------------------------------------------
			 * DOM Content Loaded is ready available
			 * @param {*} callback
			 * ------------------------------------------------------------------------
			 */
			const onDOMLoaded = (callback) => {
			  if (
				document.readyState === 'complete' ||
				document.readyState === 'interactive'
			  ) {
				document.addEventListener('DOMContentLoaded', () => {
				  setTimeout(callback, 1)
				})
			  } else {
				document.addEventListener('DOMContentLoaded', callback)
			  }
			}
		  
			onDOMLoaded(datepickerBooking())
		  })()
		  

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}
		
		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} 
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}